import React, {useState} from 'react';
import {
    Button,
    Modal,
    ModalActions,
    ModalContent,
    ModalTitle,
} from "@deere/fuel-react";
import {DatePicker} from "@deere/ux.uxframe-react";

export const CampaignDueDateModal = ({setNewDueDate, handleSave}) => {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Button variant="text" onClick={handleClickOpen}>
                Change Due Date
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-Modal-title"
                aria-describedby="alert-Modal-description"
                maxWidth="md"
                fullWidth={true}
            >
                <ModalTitle onClose={handleClose} id="alert-Modal-title">
                    Change Due Date
                </ModalTitle>
                <ModalContent>
                    <DatePicker inputProps={{onChange: (date) => setNewDueDate(date?.length ? date[0] : undefined)}} />
                </ModalContent>
                <ModalActions>
                    <Button onClick={handleClose} variant="secondary">
                        Cancel
                    </Button> &nbsp; &nbsp;
                    <Button onClick={handleSave} variant="primary">
                        Update
                    </Button>
                </ModalActions>
            </Modal>
        </div>
    );
};
